module.exports = __webpack_public_path__ + "static/img/141.bb65e6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/141.png
// module id = 3cF/
// module chunks = 0